import { render, staticRenderFns } from "./EmployerMigrationPeriodForm.vue?vue&type=template&id=c20a29da"
import script from "./EmployerMigrationPeriodForm.vue?vue&type=script&lang=ts"
export * from "./EmployerMigrationPeriodForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports